export const DATE_RANGE_ANY = '';
export const DATE_RANGE_TODAY = 'today';
export const DATE_RANGE_YESTERDAY = 'yesterday';
export const DATE_RANGE_LAST_7_DAYS = 'week';
export const DATE_RANGE_LAST_30_DAYS = 'month';
export const DATE_RANGE_LAST_90_DAYS = 'quarter';
export const DATE_RANGE_CUSTOM = 'custom';
export const DATE_RANGES = {
    [DATE_RANGE_ANY]: 'Any time',
    [DATE_RANGE_TODAY]: 'Today',
    [DATE_RANGE_YESTERDAY]: 'Yesterday',
    [DATE_RANGE_LAST_7_DAYS]: 'Last 7 days',
    [DATE_RANGE_LAST_30_DAYS]: 'Last 30 days',
    [DATE_RANGE_LAST_90_DAYS]: 'Last 90 days',
    [DATE_RANGE_CUSTOM]: 'Custom',
};

export const DEFAULT_DATE_FORMAT = 'DD MMM YYYY';
export const SYSTEM_DATE_FORMAT = 'YYYY-MM-DD';
export const SYSTEM_TIME_FORMAT = 'HH:mm:ss';
export const SYSTEM_DATE_TIME_FORMAT = SYSTEM_DATE_FORMAT + ' ' + SYSTEM_TIME_FORMAT;
export const US_DATE_FORMAT = {month: 'long', year: 'numeric', day: 'numeric'};
